import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'dealer-boost-box',
  styleUrl: 'dealer-boost-box.css',
})
export class DealerBoostBox {
  @Prop() boost: number = 0;
  @Prop() dealerName: string = '';

  render() {
    return (
      <div class="py-6">
        <div class="text-center text-white bg-clrs-dark-green rounded ">
          <div class="py-2">
            <div class="text-center">
              <div>
                <span class="font-bold text-lg">You Received A Dealer Boost!</span>
                <br />
                <span>Only at {this.dealerName}</span>
              </div>
            </div>
            <div class="text-center mt-1">
              <div class="text-2xl font-bold">${this.boost}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
